module.exports = __webpack_public_path__ + "static/media/ICT-10.16f2d83e.png";